!((document, Drupal, $) => {
  'use strict';

  // Function to Display Year
  function showYear(years, contentYear) {
    let gateTop = document.querySelector('.gate-top');
    let gateBottom = document.querySelector('.gate-bottom');
    for (let i = 0; i < contentYear.length; i++) {
      let contentYearItem = contentYear.item(parseInt(i));
      let contentYearTop = contentYearItem.getBoundingClientRect().top;
      let contentYearTopHeight = $(contentYearItem).outerHeight();
      if ((contentYearTop + contentYearTopHeight - 200) >= ($('.region-header').outerHeight())) {
        console.log('contentYearItem: ' + contentYearItem.getAttribute('data-year'));
        for (var j = 0; j < years.length; j++) {
          let yearsItem = years.item(parseInt(j));
          if (yearsItem.getAttribute('data-year') === contentYearItem.getAttribute('data-year')) {

            console.log('yearsItem: ' + yearsItem.getAttribute('data-year'));
            if (yearsItem.classList.contains('next') || yearsItem.classList.contains('past')) {
              gateTop.classList.add('animate');
              gateBottom.classList.add('animate');
              setTimeout(function () {
                gateTop.classList.remove('animate');
                gateBottom.classList.remove('animate');
              }, 500);
            }
            setTimeout(function () {
              $('.year').removeClass('current');
              $('.year').removeClass('next');
              $('.year').removeClass('past');
              yearsItem.classList.add('current');
              yearsItem.previousElementSibling.classList.add('past');
              yearsItem.nextElementSibling.classList.add('next');
            }, 500);
            break;
          }
        }
        break;
      }
    }
  }

  /**
   * Use this to describe what your behavior does.
   */
  Drupal.behaviors.historyOfGrowth = {
    attach: function () {
      let years = document.querySelectorAll('.year');
      let contentYear = document.querySelectorAll('.year-container');
      if (years.length > 1) {
        years[0].classList.add('current');
        years[1].classList.add('next');
        showYear(years, contentYear);
        window.addEventListener('scroll', function () {
          showYear(years, contentYear);
          var $sticky = $('.date-container');
          $sticky.addClass('sticky');
        }, { passive: true });
      }

    }
  };
})(document, Drupal, jQuery);
